import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles

import "./App.css";
import Footer from "./pages/Footer";
import WhatsAppButton from './components/WhatsAppButton';
import Header from "./pages/Header";
import TopBar from "./pages/TabBar";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const location = useLocation();

  // AOS Initialization
  useEffect(() => {
    AOS.init({
      duration: 800,     // Animation duration
      once: true,        // Whether animation should happen only once
      easing: "ease-in-out",
    });
  }, []);

  // These checks help conditionally render Header/Footer
  const isAdminRoute = location.pathname.startsWith("/admin-panel");
  const isHomeRoute = location.pathname === "/";
  const isEventSRoute = location.pathname === "/EventS";
  const isExamcellSRoute = location.pathname === "/Examcell";
  const isAdminloginRoute = location.pathname === "/admin-login";
  const isMainPageRoute = location.pathname === "/mainpage";

  return (
    <div className="overflow-x-hidden">
      <ScrollToTop />

      <main>
        {!isAdminRoute && !isAdminloginRoute && !isHomeRoute && !isMainPageRoute && <Header />}
        <Outlet />
      </main>

      {!isAdminRoute && !isAdminloginRoute && <Footer />}
      <TopBar />
      <WhatsAppButton />
    </div>
  );
}

export default App;
